import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({ name: 'indStdNumber' })

export class IndStdNumberPipe extends DecimalPipe implements PipeTransform {
  transform(value: any): any {
    const isNumber = typeof (value) === 'number' ? true :
      typeof (value) === 'string' ? +value !== NaN ? true : false : false;
    return isNumber ? super.transform(+value, '', 'en-In') || value : value;
  }
}
